import { BRAND_DISPLAY_NAME, BRAND_OWNER, CONTACT_EMAIL } from './brand.js';
import { ROUTE_META } from './meta.js';
import { FAQ_STRUCTURED_DATA } from './faq.js';

// Shared by initial HTML and browser updates. Only factual, public site data;
// no fabricated ratings, offers or claims of construction approval.
export function routeStructuredData(path, origin, extra = null) {
    const meta = ROUTE_META[path] || ROUTE_META['/'];
    const canonical = origin + (meta.canonicalPath || path);
    return {
        website: {
            '@context': 'https://schema.org', '@type': 'WebSite',
            name: BRAND_DISPLAY_NAME, url: origin + '/', description: ROUTE_META['/'].description,
            publisher: { '@id': origin + '/#organization' },
        },
        organization: {
            '@context': 'https://schema.org', '@type': 'Organization', '@id': origin + '/#organization',
            name: BRAND_OWNER, alternateName: BRAND_DISPLAY_NAME, url: origin + '/',
            logo: origin + '/images/keystone-mark.svg', email: CONTACT_EMAIL,
        },
        webpage: {
            '@context': 'https://schema.org', '@type': 'WebPage', name: meta.title, url: canonical,
            description: meta.description, isPartOf: { '@type': 'WebSite', url: origin + '/' },
            publisher: { '@id': origin + '/#organization' }, author: { '@id': origin + '/#organization' },
        },
        breadcrumb: path === '/' ? null : {
            '@context': 'https://schema.org', '@type': 'BreadcrumbList',
            itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Home', item: origin + '/' },
                { '@type': 'ListItem', position: 2, name: meta.title.split(' - ')[0], item: canonical },
            ],
        },
        extra: extra || (path === '/faq' ? FAQ_STRUCTURED_DATA : null),
    };
}
